export const initialProps = {
	featureAppId: 'vw-masters-carretera',
};

export class Environment {
	private static _instance: Environment;
	public props: any = initialProps;

	private constructor(env: EnvironmentEnum) {
		const propertiesByEnv = {
			[EnvironmentEnum.LOCALHOST]: {
				portal: 'es-portal-int',
				beneficios: 'es-portal-beneficios',
			},
			[EnvironmentEnum.INT]: {
				portal: 'es-portal-int',
				beneficios: 'es-portal-beneficios',
			},
			[EnvironmentEnum.PRE]: {
				portal: 'es-portal',
				beneficios: 'es-portal-beneficios',
			},
			[EnvironmentEnum.PRO]: {
				portal: 'es-portal',
				beneficios: 'es-portal-beneficios',
			},
		};

		this.props = {
			...this.props,
			...propertiesByEnv[env],
		};
	}

	public static getInstance(env?: EnvironmentEnum) {
		let result = null;
		if (this && !this._instance && !env) {
			result = {
				props: {
					...initialProps,
				},
			};
		}
		result = this._instance || (this._instance = new this(env as EnvironmentEnum));

		return result.props;
	}
}

export enum EnvironmentEnum {
	LOCALHOST = 'LOCALHOST',
	INT = 'INT',
	PRE = 'PRE',
	PRO = 'PRO',
}
